import { render, staticRenderFns } from "./EmailTemplatesListPage.vue?vue&type=template&id=2737ea83&scoped=true&"
import script from "./EmailTemplatesListPage.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplatesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplatesListPage.vue?vue&type=style&index=0&id=2737ea83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2737ea83",
  null
  
)

export default component.exports